import React from 'react';
import PropTypes from 'prop-types';

class ToolTab extends React.Component {
  static displayName = 'ToolTab';

  static propTypes = {
    children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
  };

  render() {
    const { children } = this.props;

    return children;
  }
}

export default ToolTab;
